import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { userid, currentTenant } from '../../Common/Credentials.js';
import SizeServices from './SizeServices.js';
import { Spinner } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import size from '../../Excel Templets/Size.xlsx';
import { SelectableRadio } from "../../NewUI/NewComponents/SelectableRadio.jsx";
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';

const NewSize = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pagename } = location.state || { pagename: 'New Size' };

  const [sizeList, setSizeList] = useState([]);
  const [sizeVal, setSizeVal] = useState('');
  const [message, setMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const [type, setType] = useState(false); // false = manual, true = bulk
  const [hovered, setHovered] = useState(null);

  const downloadExcel = () => {
    const link = document.createElement("a");
    link.href = size;
    link.download = 'Size';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => window.URL.revokeObjectURL(link.href), 200);
  };

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: 'buffer' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        resolve(data);
      };
      fileReader.onerror = error => reject(error);
    });

    promise.then((d) => {
      setSizeList(d.map(e => e.Size));
    });
  };

  const onSubmit = (values) => {
    setLoader(true);
    const addsize = {
      name: values.size,
      tenantid: currentTenant
    };
    SizeServices.addsize(addsize)
      .then(() => navigate('/size'))
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate('/');
        }
        setMessage(e.response?.data?.message || 'Error');
        setLoader(false);
      });
  };

  const uploadSize = () => {
    if (sizeList.length === 0) return;
    setLoader(true);
    const uploadsize = {
      names: sizeList,
      tenantid: currentTenant
    };
    SizeServices.UploadSizes(uploadsize)
      .then(() => navigate('/size'))
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate('/');
        }
        setMessage(e.response?.data?.message || 'Error');
        setLoader(false);
      });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.size || values.size.trim() === '') {
      errors.size = "Size is Required";
    }
    return errors;
  };

  return (
    <div>
                        <Header/>
            <Menu/>
            <div className="content-wrapper">
      {loader && (
        <div className="UI-loading-overlay">
          <div className="UI-spinner"></div>
        </div>
      )}

      <div className="UI-container">
        <div className="UI-card">
          <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Sizes",path:"/size"},{name:pagename,path:null}]}/>

            <div className="UI-header-content">
              <div>
                <h1 className="UI-title">{pagename}</h1>
                <p className="UI-subtitle">
                  {type ? 'Upload multiple sizes' : 'Create a new size'}
                </p>
              </div>
              <div className="UI-header-actions">
                <button
                  onClick={() => navigate(-1)}
                  className={`UI-btn UI-btn-outline ${hovered === "back" ? "UI-btn-outline-hover" : ""}`}
                  style={{
                    backgroundColor: hovered === "back" ? "#4d4d4d" : "#ffffff",
                    color: hovered === "back" ? "#fff" : "#4d4d4d",
                    transform: hovered === "back" ? "scale(1.02)" : "scale(1)",
                    border: '1px solid #4d4d4d',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={() => setHovered("back")}
                  onMouseLeave={() => setHovered(null)}
                >
                  ← Back
                </button>
              </div>
            </div>
          </div>

          <div className="UI-form-container">
            <div className="UI-switch-container">
              <span className="UI-switch-label">Entry Mode</span>
              <div className="d-flex" style={{ alignItems: "center", gap: "20px" }}>
                <div
                  className="d-flex cursor-pointer"
                  style={{ alignItems: "center", gap: "8px" }}
                  onClick={() => { setType(false); setSizeList([]); }}
                >
                  <SelectableRadio checked={!type} size="md" />
                  <span style={{ fontSize: "13px", color: "#1e293b" }}>Add manually</span>
                </div>
                <div
                  className="d-flex cursor-pointer"
                  style={{ alignItems: "center", gap: "8px" }}
                  onClick={() => { setType(true); setSizeVal(''); }}
                >
                  <SelectableRadio checked={type} size="md" />
                  <span style={{ fontSize: "13px", color: "#1e293b" }}>By upload</span>
                </div>
              </div>
            </div>

            {!type ? (
              <Formik
                initialValues={{ size: sizeVal }}
                onSubmit={onSubmit}
                validateOnChange={false}
                validate={validate}
                enableReinitialize
              >
                {() => (
                  <Form autoComplete="off">
                    <div className="UI-form-section">
                      <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>
                        Size Details
                      </h3>
                      <div className="UI-form-grid">
                        <div className="UI-form-group">
                          <label className="UI-label">Size *</label>
                          <input
                            type="text"
                            name="size"
                            className={`UI-input ${message ? 'UI-input-error' : ''}`}
                            placeholder="Enter size"
                            value={sizeVal}
                            onChange={(e) => { setSizeVal(e.target.value); setMessage(''); }}
                          />
                          {message && <div className="UI-error-text">{message}</div>}
                        </div>
                      </div>
                    </div>

                    <div className="UI-btn-actions">
                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className={`UI-btn UI-btn-outline ${hovered === "cancel" ? "UI-btn-outline-hover" : ""}`}
                        style={{
                          backgroundColor: hovered === "cancel" ? "#4d4d4d" : "#ffffff",
                          color: hovered === "cancel" ? "#fff" : "#4d4d4d",
                          transform: hovered === "cancel" ? "scale(1.03)" : "scale(1)",
                          border: '1px solid #4d4d4d',
                          cursor: 'pointer'
                        }}
                        onMouseEnter={() => setHovered("cancel")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={loader}
                        className={`UI-btn UI-btn-primary ${hovered === "submit" ? "UI-btn-primary-hover" : ""}`}
                        style={{
                          opacity: loader ? 0.6 : 1,
                          transform: hovered === "submit" ? "scale(1.07)" : "scale(1)",
                        }}
                        onMouseEnter={() => setHovered("submit")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        {loader ? <><Spinner animation="border" size="sm" /> Saving...</> : 'Save'}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            ) : (
              <div className="UI-form-section">
                <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>
                  Bulk Upload
                </h3>

                <div className="UI-form-group">
                  <button
                    type="button"
                    onClick={downloadExcel}
                    className={`UI-btn UI-btn-success ${hovered === "downloadExcel" ? "UI-btn-success-hover" : ""}`}
                    style={{ transform: hovered === "downloadExcel" ? "scale(1.05)" : "scale(1)" }}
                    onMouseEnter={() => setHovered("downloadExcel")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    📥 Download Sample Excel
                  </button>
                  <div className="UI-helper-text">
                    The Excel sheet must contain a column named 'Size'. Supports .xlsx, .xls, .csv.
                  </div>
                </div>

                <div className="UI-form-group">
                  <label className="UI-label">Upload Excel File</label>
                  <div
                    className={`UI-file-upload-area ${hovered === "uploadExcel" ? "UI-file-upload-active" : ""}`}
                    style={{
                      transform: hovered === "uploadExcel" ? "scale(1.01)" : "scale(1)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      position: 'relative'
                    }}
                    onClick={() => document.getElementById('fileInput').click()}
                    onMouseEnter={() => setHovered("uploadExcel")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <input
                      id="fileInput"
                      type="file"
                      accept=".xlsx,.xls,.csv"
                      className="UI-file-upload-input"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) readExcel(file);
                        e.target.value = '';
                      }}
                    />
                    <div style={{ fontSize: "0.85rem", fontWeight: 500 }}>Click to upload Excel file</div>
                    <div style={{ marginTop: "6px", fontSize: "0.7rem", color: "#64748b" }}>
                      Supported formats: .xlsx, .xls, .csv (Max 5MB)
                    </div>
                  </div>
                </div>

                {sizeList.length > 0 && (
                  <div className="UI-form-group">
                    <label className="UI-label">Preview ({sizeList.length} items)</label>
                    <div className="UI-preview-list" style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px' }}>
                      {sizeList.map((item, idx) => (
                        <span key={idx} className="UI-preview-item">
                          {idx + 1}. {item}
                          {idx < sizeList.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                <div className="UI-btn-actions">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className={`UI-btn UI-btn-outline ${hovered === "cancelBulk" ? "UI-btn-outline-hover" : ""}`}
                    style={{
                      backgroundColor: hovered === "cancelBulk" ? "#4d4d4d" : "#ffffff",
                      color: hovered === "cancelBulk" ? "#fff" : "#4d4d4d",
                      transform: hovered === "cancelBulk" ? "scale(1.03)" : "scale(1)",
                      border: '1px solid #4d4d4d',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={() => setHovered("cancelBulk")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={uploadSize}
                    disabled={loader || sizeList.length === 0}
                    className={`UI-btn UI-btn-primary ${hovered === "saveBulk" ? "UI-btn-primary-hover" : ""}`}
                    style={{
                      opacity: loader || sizeList.length === 0 ? 0.6 : 1,
                      transform: hovered === "saveBulk" ? "scale(1.07)" : "scale(1)",
                    }}
                    onMouseEnter={() => setHovered("saveBulk")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    {loader ? <><Spinner animation="border" size="sm" /> Saving...</> : 'Save'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
            </div>
                  <Footer/>
    </div>
  );
};

export default NewSize;